module.exports = __webpack_public_path__ + "static/media/small-logo.03949b93.png";